// Select the target node (usually the body or a specific container)
const targetNode = document.body;

// Create an observer instance linked to the callback function
const observer = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Loop through added nodes to see if any match the class 'STP-tiers'
            for (let node of mutation.addedNodes) {
                if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('STP-tiers')) {
                    // Element with class 'STP-tiers' was added
                    console.log('Element with class "STP-tiers" added:', node);

                    // Execute your code here
                    executeMyCode(node);

                    // Optionally disconnect the observer if you only want to run once
                    // observer.disconnect();
                }
            }
        }
    }
});

// Options for the observer (which mutations to observe)
const config = { childList: true, subtree: true };

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

// Function to execute when element is added
function executeMyCode(element) {
    function replaceTextInElement(element, searchText, replacementText) {
        if (element) {
            // Vervang alleen in tekstinhoud van het element zelf, niet in child elements
            element.innerHTML = element.innerHTML.replace(new RegExp(searchText, 'g'), replacementText);
        } else {
            console.warn('Het doelelement is niet gevonden.');
        }
    }
    replaceTextInElement(element, 'EUR', '');
    replaceTextInElement(element, '€', '');

}